import * as React from 'react'
import { CurrencyContext } from '../context/CurrencyContext'

const useCurrencyContext = () => {
    return React.useContext(CurrencyContext)
}

export default useCurrencyContext
